import { API_URL, getCachedSessionId } from 'src/services/common';
import { api } from '../../../../util/axios-instance';

export const updateUser = async (id, userId, data) => {
  const response = await api.put(`${API_URL}/v1/project/${id}/user/${userId}`, data, {
    headers: { 'x-session-id': getCachedSessionId() }
  });

  return response?.data;
};
